<nav class="navigation-container {{ project }}" *ngIf="navigationItems$ | async as items">
  <div class="content {{ project }}" *ngIf="items.length >= 1">
    <ng-container *ngFor="let item of items">
      <a *ngIf="item.link" [customRouterLink]="item.link" class="item {{ item.link.title === 'Sale' ? 'bold' : '' }} {{ project }}" (mouseenter)="setItem(item.id)" (mouseleave)="removeItemAfterTime()">{{ item.link.title }}</a>
      <ng-container *ngIf="flyOutItemId === item.id">
        <div class="fly-out-item" *ngIf="item.children.length > 0" (mouseenter)="isInside()" (mouseleave)="removeItem()">
          <div class="fly-out-content">
            <ng-container *ngFor="let childItemFirst of item.children">
              <div class="fly-out-row">
                <a *ngIf="childItemFirst.link" [customRouterLink]="childItemFirst.link" class="fly-out-item-label">{{ childItemFirst.link.title }}</a>
                <div class="flyout-nav-row" *ngIf="childItemFirst.children">
                  <ng-container *ngFor="let childItemSecond of childItemFirst.children">
                    <a *ngIf="childItemSecond.link" [customRouterLink]="childItemSecond.link" class="fly-out-item-link">{{ childItemSecond.link.title }}</a>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="burger-menu-content" (click)="toggleBurgerMenu()" tabindex="1">
    <div class="icon" [hidden]="burgerMenuOpened">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill="#222" fill-rule="evenodd" d="M17.143 15v1.429H2.857V15h14.286zm0-5.714v1.428H2.857V9.286h14.286zm0-5.715V5H2.857V3.571h14.286z"/>
      </svg>
    </div>
    <div class="icon" [hidden]="!burgerMenuOpened">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M17.412 3.588L16.412 2.588 10 9 3.561 2.561 2.561 3.561 9 10 2.561 16.439 3.561 17.439 10 11 16.439 17.439 17.439 16.439 11 10z"/>
      </svg>
    </div>
  </div>
  <div class="burger-navigation" #burgerNavigation>
    <div class="nav-content">
      <ng-container *ngFor="let item of items">
        <div class="nav-item" *ngIf="!mobileFirstItem">
          <ng-container *ngIf="item.children.length > 0; else asLink">
            <a (click)="setFirstItem(item)" class="item">{{ item.link.title }}</a>
          </ng-container>
          <ng-template #asLink>
            <a *ngIf="item.link" [customRouterLink]="item.link" class="item">{{ item.link.title }}</a>
          </ng-template>
        </div>
        <div class="nav-item column" *ngIf="mobileFirstItem && item.id === mobileFirstItem.id && !mobileSecondItem">
          <div class="back" (click)="unsetFirstItem()"> {{ item.link.title }} <a [customRouterLink]="item.link" class="linkRef">{{ 'navigation.mobile.section.show.description' | translate }}</a> </div>
          <div *ngFor="let firstItem of item.children">
            <ng-container *ngIf="firstItem.children.length > 0; else asLink">
              <a (click)="setSecondItem(firstItem)" class="item">{{ firstItem.link.title }}</a>
            </ng-container>
            <ng-template #asLink>
              <a *ngIf="firstItem.link" [customRouterLink]="firstItem.link" class="item">{{ firstItem.link.title }}</a>
            </ng-template>
          </div>
        </div>
        <div class="nav-item column" *ngIf="mobileSecondItem && item.id === mobileFirstItem.id">
          <div class="back" (click)="unsetSecondItem()"> {{ mobileSecondItem.link.title }} <a [customRouterLink]="mobileSecondItem.link" class="linkRef">{{ 'navigation.mobile.section.show.description' | translate }}</a> </div>
          <div *ngFor="let secondItem of mobileSecondItem.children">
            <a *ngIf="secondItem.link" [customRouterLink]="secondItem.link" class="item">{{ secondItem.link.title }}</a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</nav>
